import React from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import P from '@deliveroo/consumer-component-library/components/P';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import styles from './styles.scss';

/**
 * A menu item card to display on Brand Landing Pages (i.e. not for actual menu
 * page usage).
 */
export default function BrandMenuItem({ name, description, imageUrl }) {
  return (
    <div className={styles.outer}>
      <Spacer spacing="medium">
        <div className={styles.inner}>
          <div className={styles.text}>
            <P color="black">{name}</P>
            <P color="grey" size="small" adjacentVerticalSpacing="small">
              <Truncate lines={2} ellipsis="..." trimWhitespace>
                {description}
              </Truncate>
            </P>
          </div>
          {imageUrl && (
            <Spacer adjacentHorizontalSpacing="medium">
              <div className={styles.image}>
                <BackgroundImage src={imageUrl} />
              </div>
            </Spacer>
          )}
        </div>
      </Spacer>
    </div>
  );
}

BrandMenuItem.propTypes = {
  /**
   * Name of the menu item
   */
  name: PropTypes.string.isRequired,

  /**
   * Description of the menu item.
   */
  description: PropTypes.string.isRequired,

  /**
   * Optional image URL, where available.
   */
  imageUrl: PropTypes.string,
};

BrandMenuItem.defaultProps = {
  imageUrl: undefined,
};
